import * as React from 'react';
import { useSelector } from 'react-redux';
import { EServiceId, EBetPositionStatus, ECheckServiceStatus, EPlacingType } from '../../../../redux/reducers';
import {
  selectActivePlacingType,
  selectIsPromotionPackageSelected,
  selectServiceUnavailableReason,
  selectActiveOrPromotionServiceId,
  selectIsWithoutMinimalBet,
  selectActiveServiceId,
} from '../../../../selectors/publishTerms';
import {
  selectBetPositionStatus,
  selectIsBetPositionVisible,
  selectTopAuctionBetPosition,
} from '../../../../selectors/betPosition';
import { selectCheckServiceStatus, selectPromotionCost } from '../../../../selectors/checkoutInfo';
import { selectIsTermsDurationsAvailable } from '../../../../selectors/termsDurations';
import { EPlacingLayoutType } from '../../types';
import { AnimationLayout, AnimationElement } from '../../../common/Animation';
import { BetInputContainer } from '../BetInput';
import { PromotionLabelContainer } from '../PromotionLabel';
import { ServicesContainer } from '../Services';
// После эксперимента MONEY-382 заменит старую версию выбора услуг
import { ServicesContainer as NewServices } from './components/Services';
import { BetInputLabel } from './components/BetInputLabel';
import { PackagesLayout } from './components/PackagesLayout';
import { PromotionCost } from './components/PromotionCost';
import { ServicesLayout } from './components/ServicesLayout';
import { ServiceErrorContainer } from '../ServiceError';
import { selectCurrentBet, selectIsAuctionEnabled } from '../../../../selectors/auction';
import { PackagesWithoutBetLayout } from './components/PackagesWithoutBetLayout';
import { PromotionLayout } from './components/PromotionLayout';
import { useIsMobileDevice } from '../../../../hooks';
import { getCurrentLayout } from './utils/getCurrentLayout';
import { TermsDurationsContainer } from './components/TermsDurations';
import { BetPositionMobileTooltip } from './components/BetPositionMobileTooltip';
import { getBetPositionText } from '../../utils/getBetPositionText';
import { BetPositionContainer } from '../BetPosition';
import { layoutAnimationConfig } from './constants';
import { getLeadBetPositionText } from './utils/getLeadBetPositionText';

export const PromotionSectionContainer = () => {
  const isPromotionPackageSelected = useSelector(selectIsPromotionPackageSelected);
  const isAuctionEnabled = useSelector(selectIsAuctionEnabled);
  const promotionCost = useSelector(selectPromotionCost);
  const checkServiceStatus = useSelector(selectCheckServiceStatus);
  const activeOrPromotionServiceId = useSelector(selectActiveOrPromotionServiceId);
  const betPositionStatus = useSelector(selectBetPositionStatus);
  const isBetPositionVisible = useSelector(selectIsBetPositionVisible);
  const currentBet = useSelector(selectCurrentBet);
  const placingType = useSelector(selectActivePlacingType);
  const isMobile = useIsMobileDevice();
  const unavailableReason = useSelector(selectServiceUnavailableReason);
  const isTermsDurationsAvailable = useSelector(selectIsTermsDurationsAvailable);
  const isWithoutMinimalBet = useSelector(selectIsWithoutMinimalBet);
  const topAuctionBetPosition = useSelector(selectTopAuctionBetPosition);

  const isLoading =
    checkServiceStatus === ECheckServiceStatus.pending || betPositionStatus === EBetPositionStatus.pending;

  const isWithoutMinimalBetNotInPackage = isWithoutMinimalBet && !isPromotionPackageSelected;
  const isPlacingTypePackage = placingType === EPlacingType.package;
  const selectedTopAuctionServiceId = useSelector(selectActiveServiceId);
  const betPositionWithoutMinimalBet = selectedTopAuctionServiceId === EServiceId.top && topAuctionBetPosition && (
    <BetPositionMobileTooltip>{getLeadBetPositionText(topAuctionBetPosition)}</BetPositionMobileTooltip>
  );
  const betPosition = isPlacingTypePackage
    ? isBetPositionVisible && <BetPositionContainer theme="white" />
    : getBetPositionText({ serviceId: activeOrPromotionServiceId, currentBet });

  const promotion = (!unavailableReason || isWithoutMinimalBetNotInPackage || !isPlacingTypePackage) && (
    <PromotionLayout
      loading={isLoading}
      promotionLabel={<PromotionLabelContainer />}
      betPosition={isWithoutMinimalBetNotInPackage ? betPositionWithoutMinimalBet : betPosition}
    />
  );

  const currentLayout = getCurrentLayout({ isPromotionPackageSelected, isAuctionEnabled });

  return (
    <AnimationLayout>
      <AnimationElement key={currentLayout} {...layoutAnimationConfig}>
        {currentLayout === EPlacingLayoutType.packagesWithoutBet && (
          <PackagesWithoutBetLayout promotion={promotion} error={<ServiceErrorContainer />} />
        )}

        {currentLayout === EPlacingLayoutType.packages && (
          <PackagesLayout
            promotion={promotion}
            betInputLabel={<BetInputLabel />}
            betInput={<BetInputContainer />}
            promotionCost={<PromotionCost promotionCost={promotionCost} />}
            error={<ServiceErrorContainer />}
          />
        )}

        {currentLayout === EPlacingLayoutType.services && (
          <ServicesLayout
            // На десктопе позиция отображается в тултипе внутри CommonServiceContainer
            promotion={isMobile && promotion}
            services={isWithoutMinimalBet ? <NewServices /> : <ServicesContainer />}
            error={<ServiceErrorContainer />}
          />
        )}

        {isTermsDurationsAvailable && <TermsDurationsContainer />}
      </AnimationElement>
    </AnimationLayout>
  );
};
